import tempMeeApi from '../../../apis/tempMee';

export const downloadACHAuthorizationRecord = async (bankId) => {
  const response = await tempMeeApi.get(
    `/payment/admin/account/payment-method/authorization-record/${bankId}`,
    {
      responseType: 'blob',
    },
  );

  return response.data;
};
